import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cryptowars',
  templateUrl: './cryptowars.component.html',
  styleUrls: ['./cryptowars.component.css']
})
export class CryptowarsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
